import posthog from "posthog-js";

export const NEW_UPSELL_MODAL_FLAG = 'new-upsell-modal';

export function isInNewUpsellExperiment(): boolean {
    try {
        const flag = posthog.getFeatureFlag(NEW_UPSELL_MODAL_FLAG);
        if (flag === true) return true;
        return typeof flag === 'string' && flag !== 'control';
    } catch (err) {
        return false;
    }
}
